/* HARMONY — Busca no header
   Portado do protótipo (harmony-prototype.html, "BUSCA"). No protótipo o
   índice era montado varrendo o DOM da coleção; aqui consulta de verdade
   /search/suggest.json (predictive search nativo da Shopify), com debounce e
   cancelamento da busca anterior. */
(function () {
  var DEBOUNCE_MS = 220;

  function initSearch() {
    var overlay = document.getElementById('search-overlay');
    var input = document.getElementById('search-input');
    var resultsEl = document.getElementById('search-results');
    var msgEl = document.getElementById('search-msg');
    var clearBtn = document.getElementById('search-clear');
    if (!overlay || !input || !resultsEl || !msgEl || overlay._hmyInit) return;
    overlay._hmyInit = true;

    var currency = overlay.getAttribute('data-currency') || 'BRL';
    var locale = overlay.getAttribute('data-locale') || 'pt-BR';
    var strings = {
      prompt: overlay.getAttribute('data-msg-prompt') || '',
      noResults: overlay.getAttribute('data-msg-no-results') || '',
      loading: overlay.getAttribute('data-msg-loading') || ''
    };

    var moneyFormatter;
    try {
      moneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (e) {
      moneyFormatter = { format: function (v) { return v; } };
    }

    var debounceTimer = null;
    var activeController = null;
    var requestSeq = 0;

    function updateClearButton() {
      if (!clearBtn) return;
      var hasValue = input.value.trim().length > 0;
      clearBtn.hidden = !hasValue;
      clearBtn.classList.toggle('show', hasValue);
    }

    function showMessage(text) {
      resultsEl.innerHTML = '';
      msgEl.hidden = false;
      msgEl.textContent = text;
    }

    function renderHits(products) {
      resultsEl.innerHTML = '';
      if (!products.length) {
        showMessage(strings.noResults.replace('{{ query }}', input.value.trim()));
        return;
      }
      msgEl.hidden = true;
      var frag = document.createDocumentFragment();
      products.forEach(function (product) {
        var a = document.createElement('a');
        a.className = 'search-hit';
        a.href = product.url;

        var imgHtml = '';
        if (product.featured_image && product.featured_image.url) {
          var src = product.featured_image.url;
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=88';
          imgHtml = '<img src="' + src + '" alt="" loading="lazy">';
        }

        var price = '';
        try {
          // price_min/price vêm como string decimal ("19.99"), não número
          price = moneyFormatter.format(Number(product.price_min ?? product.price));
        } catch (e) {}

        a.innerHTML = imgHtml
          + '<span><span class="sh-name"></span>'
          + '<span class="sh-meta"></span></span>';
        a.querySelector('.sh-name').textContent = product.title || '';
        a.querySelector('.sh-meta').textContent = [product.vendor, price].filter(Boolean).join(' · ');
        frag.appendChild(a);
      });
      resultsEl.appendChild(frag);
    }

    function search(query) {
      var url = (window.routes && window.routes.predictive_search_url) || '/search/suggest.json';
      // Nessa loja `routes.predictive_search_url` vem SEM o ".json" (ex.:
      // "/search/suggest"), e a Shopify responde 422 pra essa rota sem
      // extensão — a busca caía direto no .catch() e mostrava "nada
      // encontrado" mesmo quando o produto existia (bug real, não falta de
      // resultado — ex.: buscar "branca" não achava "...BRANCA"). Garante o
      // sufixo .json sempre, sem duplicar se já vier certo.
      if (url.indexOf('.json') === -1) {
        url += '.json';
      }
      var seq = ++requestSeq;
      if (activeController) activeController.abort();
      activeController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      showMessage(strings.loading);

      fetch(
        url + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8',
        { signal: activeController ? activeController.signal : undefined }
      )
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== requestSeq) return; // resposta de uma busca já obsoleta
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          renderHits(products);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (seq !== requestSeq) return;
          showMessage(strings.noResults.replace('{{ query }}', query));
        });
    }

    function render(rawQuery) {
      var query = rawQuery.trim();
      clearTimeout(debounceTimer);
      updateClearButton();
      if (!query) {
        if (activeController) activeController.abort();
        showMessage(strings.prompt);
        return;
      }
      debounceTimer = setTimeout(function () { search(query); }, DEBOUNCE_MS);
    }

    function open() {
      overlay.classList.add('open');
      input.value = '';
      render('');
      setTimeout(function () {
        try { input.focus(); } catch (e) {}
      }, 120);
    }
    function close() {
      overlay.classList.remove('open');
      clearTimeout(debounceTimer);
      if (activeController) activeController.abort();
    }

    document.querySelectorAll('.hmy-search-trigger').forEach(function (btn) {
      if (btn._hmySearchInit) return;
      btn._hmySearchInit = true;
      btn.addEventListener('click', open);
    });

    var closeBtn = document.getElementById('search-close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    input.addEventListener('input', function () { render(input.value); });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        render('');
        try { input.focus(); } catch (e) {}
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === '/' && !overlay.classList.contains('open')) {
        var t = e.target ? e.target.tagName : '';
        if (t !== 'INPUT' && t !== 'TEXTAREA') {
          e.preventDefault();
          open();
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSearch);
  document.addEventListener('shopify:section:load', initSearch);
})();
